import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SaveChatSurveyAnswerRPC } from "./saveChatSurveyAnswerRPC";

export class SaveChatSurveyAnswerRPCClientImpl extends SaveChatSurveyAnswerRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SaveChatSurveyAnswerRPC.Request): Promise<LeoRPCResult<SaveChatSurveyAnswerRPC.Response, SaveChatSurveyAnswerRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/SaveChatSurveyAnswer",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SaveChatSurveyAnswerRPC.ResponseDTO,
      SaveChatSurveyAnswerRPC.Errors.ErrorsDTO,
      SaveChatSurveyAnswerRPC.Response,
      SaveChatSurveyAnswerRPC.Errors.Errors
    >(
      response,
      "survey-respondent/SaveChatSurveyAnswer",
      SaveChatSurveyAnswerRPC.Response.fromDTO,
      SaveChatSurveyAnswerRPC.Errors.fromDTO
    );
  }
}
